import colors from './colors'

const theme = {
  colors,
  borderRadius: {
    sm: '8px',
    md: '16px',
    lg: '32px',
  },
  spacing: (factor) => `${factor * 8}px`,
}

export default theme
